<template>
  <div>
    <el-dialog custom-class="invoice-email-window" :close-on-click-modal="false" :visible.sync="innerVisible" width="480px" :title="$t('CargoMsg.Cargo_SupplementaryInformation')" @close="innerVisible=false">
      <el-form style="padding: 5px">
        <el-form-item>
          <span>1.{{ $t('CargoMsg.Cargo_InvoiceTypeOfTheOppositePlatform') }}</span>
          <el-select v-model="invoiceType" no="1" style="width: 240px;padding-left: 20px">
            <el-option
              v-for="(item,index) in invoiceTypeList"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <el-form style="padding: 5px">
        <span> {{ rowData.length === 0?'2.' + $t('Message.ContactAndEmailAreNotMaintained') + ':':'2.' + $t('Message.PleaseSelectTheMaintainedContactAndMailbox') + ':' }}</span>
        <div class="app-main-inner-row">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :style="{width:'380px',height:'150px'}"
            @gridReady="onGridReady"
          />
        </div>
      </el-form>
      <el-form style="padding-top: 50px">
        <el-form-item>
          <span>3.{{ $t('Message.PleaseSupplementOtherMailboxes') }}:</span><span>({{ $t('Message.PleaseSeparateMultipleEmailAddressesWithCommas') }})</span>
        </el-form-item>
        <el-form-item class="el-form-item-textarea">
          <el-input v-model="mailInputTextArea" no="2" type="textarea" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <span>
          <el-button no="3" type="primary" @click="sendButtonClick">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
          <el-button no="4" @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getContacts } from '@/api/partner/contact'
import { ltsInvoiceTypeFunc, relationEmailFunc } from '@/api/clearing/invoice'
import { getGridSelected } from '@/utils/agGrid'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'EmailEnterTitleWindow',
  props: {
    visible: { type: Boolean, required: true },
    invoice: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      invoiceTypeList: [],
      selectedDataList: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCopyRowsToClipboard: true,
        suppressRowSelection: true,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        onRowSelected: this.onRowSelected,
        onRowDataChanged: event => {
          // 勾选上之前选中的
          event.api.clearFocusedCell()
          if (this.rowData.length > 0) {
            setTimeout(() => {
              if (this.gridApi.rowModel.rowsToDisplay) {
                for (const p of this.gridApi.rowModel.rowsToDisplay) {
                  if (this.selectedDataList) {
                    const index = this.selectedDataList.findIndex(pp => pp.email === p.data.email)
                    if (index > -1) {
                      p.selected = true
                    }
                  }
                }
              }
              this.gridApi.onGroupExpandedOrCollapsed()
            }, 100)
          }
        },
        pagination: false
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true },
        { headerName: this.$t('CargoMsg.Cargo_Contact'), field: 'contactPerson', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_email'), field: 'email', width: 200 }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      mailInputTextArea: '',
      invoiceType: ''
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  mounted() {

  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
    },
    toQuery() {
      if (!this.invoice) {
        this.$message.warning(this.$t('Message.InvoiceUuidCannotBeBlank'))
        return
      }
      const accountId = this.invoice.accountId
      if (!accountId || accountId === 0) {
        this.$message.warning(this.$t('Message.TheSettlementUnitIDCannotBeEmpty'))
        return
      }
      const invoiceEmail = this.invoice.email
      this.loading = getLoading4Cxt(this)
      Promise.all([
        getContacts({ cmpIdx: accountId }),
        ltsInvoiceTypeFunc()
      ]).then(results => {
        this.rowData = results[0].data
        this.selectedDataList = []
        // 展示之前的邮箱
        if (invoiceEmail) {
          const ieList = invoiceEmail.split(',')
          for (const ie of ieList) {
            const data = this.rowData.find(p => p.email === ie)
            if (data) {
              this.selectedDataList.push(data)
            } else {
              if (this.mailInputTextArea) {
                this.mailInputTextArea += ','
              }
              this.mailInputTextArea += ie
            }
          }
        }
        const rList = results[1].data
        if (rList) {
          this.invoiceTypeList = rList
          this.invoiceType = this.invoice.settleDepartmentPrefix
        }
        this.loading.close()
      }).catch(() => {
        this.loading.close()
      })
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
    },
    getSelections() { // 获取勾选的项目
      return getGridSelected(this.gridOptions)
    },
    // 发送
    sendButtonClick() {
      let mailStr = '' // this.mailInputTextArea
      for (const contact of this.selectedDataList) {
        if (!StrUtils.isEmpty(contact.email)) {
          mailStr += (StrUtils.isEmpty(mailStr) ? '' : ',') + contact.email
        }
      }
      const mailInput = this.mailInputTextArea.replace(/[\r\n]/g, '')
      if (!StrUtils.isEmpty(mailInput)) {
        mailStr += (StrUtils.isEmpty(mailStr) ? '' : ',') + mailInput
      }
      mailStr = mailStr.replace(/\ +/g, '').replace('，', ',')
      if (StrUtils.isEmpty(mailStr)) {
        this.$confirm(this.$t('Message.PleaseEnterYourEmailAddress'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          return
        }).catch(() => { })
        return
      }
      //
      this.loading = getLoading4Cxt(this)
      relationEmailFunc({
        'invoiceKey': this.invoice.uuid,
        'emailString': mailStr,
        'invoiceType': this.invoiceType,
        'transportList': this.invoice.transportList || []
      }).then(res => {
        if (res.data) {
          this.$emit('relationEmailSuccess', this.invoice.uuid)
        }
      }).finally((e) => {
        this.loading.close()
      })
    },
    // 取消
    closeHandler() {
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
.invoice-email-window {
  .el-form-item-textarea {
    width: 380px;
    padding-left: 10px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 380px;
      .el-textarea__inner {
        padding: 2px 4px;
        height: 40px;
        resize:none;
      }
    }
  }
}
</style>
